import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class Complicity extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="Complicity">
        <Header
          props={this.props}
        />
        <div className="Complicity-head-image">
            <div id="complicity-text">
              <div id="header-complicity">
                <i>Complicity:</i>
              </div>
              an experiment in the outsourcing of labor.
            </div>
        </div>
        <div className="Complicity-split">
          <div id="Complicity-split-color">
            <div id="Complicity-split-text">
              By viewing the processes involved with the transportation of goods
              the human cost of capitalism's advancement can be examined.
            </div>
          </div>
          <div id="Complicity-split-image">
           <img src="http://payload312.cargocollective.com/1/12/398889/8540354/Spacers-Resize_733.jpg" alt=""/>
          </div>
        </div>
        <div className="Complicity-three">
          <div className="Complicity-images">
            <img src="http://payload312.cargocollective.com/1/12/398889/8540354/ScreenprintResize_722.jpg" alt=""/>
            <img src="http://payload312.cargocollective.com/1/12/398889/8540354/Main-Resize_660.jpg" alt=""/>
            <img src="/images/Complicity-Header.jpg" alt=''/>
          </div>
        </div>
        <div className="Complicity-wide-three">
          <div className="Complicity-images-three">
            <img src="http://payload312.cargocollective.com/1/12/398889/8540354/PaperResize_994.jpg" alt=""/>
              <div id="complicity-second-text">
                The Birch tree stands as a symbolic representation of capitalism’s greatness, <br />
                playing off of the scale which views capitalism as the backbone of modern accomplishment.<br />
                The slices of the tree then make the solid, formidable object appear frail,
                revealing the gaps and problems that aren’t easily visible from afar.<br />
              </div>
            <img src="http://payload312.cargocollective.com/1/12/398889/8540354/CloseupResize_1000.jpg" alt=""/>
            <img src="http://payload312.cargocollective.com/1/12/398889/8540354/BoxResize_1000.jpg" alt=''/>
          </div>
        </div>
        <div id="complicity-screenprint-text">
                All that is solid— <br />
                from the clothes on our backs <br />
                to the looms and mills that weave them, <br />
                to the men and women who work the machines, <br />
                to the houses and neighborhoods the workers live in, <br />
                to the firms and corporations that exploit the workers, <br />
                to the towns and cities and whole regions <br />
                and even nations that embrace them all— <br />
                all these are made to be broken tomorrow, <br />
                smashed or shredded or pulverized or dissolved, <br />
                so they can be recycled or replaced next week, <br />
                and the whole process can go on again and again, hopefully forever, <br />
                in ever more profitable forms. <br />
            </div>

      </div>
    );
  }
}

export default Complicity;



//           <StackGrid
//           columnWidth={width <= 900 ? '33.3%' : '33.3%'}
//           monitorImagesLoaded={true}
//           gutterWidth={20}
//           gutterHeight={30}
//           style={{margin: "10px"}} >
//           <div>
//             <img src="/images/Complicity-Header.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/ScreenprintResize_722.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/Spacers-Resize_733.jpg" id="hawaii-image" alt=""/>
//           </div>
//           </StackGrid>
//           <StackGrid
//           columnWidth={width <= 900 ? '50%' : '50%'}
//           monitorImagesLoaded={true}
//           gutterWidth={10}
//           gutterHeight={30}
//           style={{margin: "10px"}} >
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/PaperResize_994.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/CloseupResize_1000.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/BoxResize_1000.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/UPREsize_737.jpg" id="hawaii-image" alt=""/>
//           </div>
//           <div>
//             <img src="http://payload312.cargocollective.com/1/12/398889/8540354/906045_563510307121023_4543651429652249564_o_1000.jpg" id="hawaii-image" alt=""/>
//           </div>
//           </StackGrid>
//           <div id="complicity-screenprint-text">
//           Screenprint Text: <br /><br />
//             All that is solid— <br />
//             from the clothes on our backs <br />
//             to the looms and mills that weave them, <br />
//             to the men and women who work the machines, <br />
//             to the houses and neighborhoods the workers live in, <br />
//             to the firms and corporations that exploit the workers, <br />
//             to the towns and cities and whole regions <br />
//             and even nations that embrace them all— <br />
//             all these are made to be broken tomorrow, <br />
//             smashed or shredded or pulverized or dissolved, <br />
//             so they can be recycled or replaced next week, <br />
//             and the whole process can go on again and again, hopefully forever, <br />
//             in ever more profitable forms. <br />
//           </div>

// <div classname="Complicity-quote">
//           “To be modern is to find ourselves in an environment that promises us adventure, power, joy, growth, transformation of ourselves and the world - and at the same time that threatens to destroy everything we have, everything we know, everything we are.”
//         </div>